import React, { FC, useContext } from "react"
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSignIn, faUser } from "@fortawesome/pro-duotone-svg-icons"
import { authContext } from "../../../context/auth/authContext"

const LogoutAlias: FC = () => {
  const context = useContext(authContext)

  const renderTooltip = props => (
    <Tooltip id="logout-as-alias" {...props}>
      Logout as Alias
    </Tooltip>
  )

  return context.aliased ? (
    <>
      <p className="text-danger ml-3 mr-3 mt-auto mb-auto">
        Alias: {context.user.username}
      </p>
      <OverlayTrigger key="bottom" placement="bottom" overlay={renderTooltip}>
        <Button
          variant="outline-danger"
          onClick={context.aliasLogout}
          className="h-75 m-auto"
          data-test="overlay"
        >
          <FontAwesomeIcon icon={faUser} />
          <FontAwesomeIcon icon={faSignIn} />
        </Button>
      </OverlayTrigger>
    </>
  ) : (
    <></>
  )
}

export default LogoutAlias
